import React from "react";
import { Column } from "@ant-design/plots";
import { formatDataNumberToen } from "../../../helper/helper";
import styled from "styled-components";

export default function DashboardAirtime({
  dataDashboard,
  isHiddenContainer = false,
  width = 600,
}) {
  const { data, xField, yField, seriesField } = dataDashboard;
  const config = {
    data,
    isGroup: true,
    xField: xField,
    yField: yField,
    seriesField: seriesField,
    // dodgePadding: 2,
    label: null,
    color: ({ name }) => {
      if (name === 'totalAdvance') {
        return '#cbbe00';
      } else if (name === 'totalAdvanceFee') {
        return '#6395fa'; 
      } else {
        return '#63daab'; 
      }
    },
    tooltip: {
      shared: true,
      showMarkers: false,
      customItems: (originalItems) => {
        return originalItems.map((item) => ({
          ...item,
          value: formatDataNumberToen(+item.value),
        }));
      },
    },
    yAxis: {
      label: {
        formatter: (v) => ` ${formatDataNumberToen(+v)} `,
      },
    },
  };

  return (
    <Container
      className={`${!isHiddenContainer ? "container" : ""}`}
      width={width}
    >
      <Column {...config} />
    </Container>
  );
}
const Container = styled.div`
  width: 100%;
  overflow-x: auto;

  .dash-board {
    min-width: ${(props) => props.width}px;
    overflow: auto;
  }
`;
